var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateTableBody } from "@/core/table/table-utils";
import HttpClient from "@/lib/http/http-client";
import { downloadFile, parseHead } from "./utils";
/**
 * Export endpoints
 */
export const EXPORT_ENDPOINTS = {
    xlsx: "/webapi/export/data-table",
    pdf: "/webapi/export/data-table-pdf",
};
/**
 * Export data to Excel or PDF
 * For PDF exports, this now returns immediately and the file is generated in background
 */
export function exportData(_a) {
    return __awaiter(this, arguments, void 0, function* ({ format, fields, data, filename, }) {
        try {
            const rawfilename = filename || `export.${format}`;
            const cleanFilename = rawfilename.replace(/\.[^/.]+$/, "").replace(/\s+/g, "_");
            const now = new Date();
            const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
            const fullFilename = `${cleanFilename}_${timestamp}.${format}`;
            const params = {
                head: parseHead(fields),
                body: generateTableBody(data, fields),
                filename: fullFilename,
            };
            const url = EXPORT_ENDPOINTS[format];
            if (format === 'pdf') {
                // PDF exports are now async - file is generated in background
                const response = yield HttpClient.post(url, params);
                return response;
            }
            else {
                // Excel exports are still synchronous
                const response = yield HttpClient.post(url, params);
                downloadFile(response.download_url, filename);
                return response;
            }
        }
        catch (error) {
            console.error(`Error exporting to ${format}:`, error);
            throw error;
        }
    });
}
